module.exports = "/images/ec-w.svg?72f5aaea8948c81c4f6bc5489f739d63";